// Test IDs for the site-wide AI compliance chat widget.

export const CHAT_WIDGET = {
  toggleButton: 'chat-widget-toggle-button',
  panel: 'chat-widget-panel',
  closeButton: 'chat-widget-close-button',
  messageList: 'chat-widget-message-list',
  message: (i) => `chat-widget-message-${i}`,
  input: 'chat-widget-input',
  sendButton: 'chat-widget-send-button',
  errorBanner: 'chat-widget-error-banner',
  disclaimer: 'chat-widget-disclaimer',
};
